export enum RouteType {
  PRIVATE = "private",
  PUBLIC = "public"
}
